// extracted by mini-css-extract-plugin
export var productsContainer = "styles-module--productsContainer--1fb76";
export var productsContainerLink = "styles-module--productsContainerLink--2fa51";
export var productsContent = "styles-module--productsContent--9294a";